import {
  compose, getContext, withHandlers,
} from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { identity, pathOr } from 'ramda';
import CompleteSprintModal from './completeSprintModal';
import { projectActions, projectSelectors } from '../../../../../state/project';
import { withSprintsCRUDHandlers } from '../../../../../utils/enchancers';
import { getModal } from '../../../../../state/ui/selectors';
import { SPRINT_STATUS } from '../../../../../constants/sprints';
import { callNotification } from '../../../../../utils/helpers/notifies';

const mapStateToProps = (state, { selectedSprintId }) => ({
  isOpen: getModal(state)('completeSprintModal'),
  isPending: projectSelectors.getDeleteSprintRequestPending(state),
  sprint: projectSelectors.getProjectSprint(state)(selectedSprintId),
});

const mapDispatchToProps = {
  updateSprint: projectActions.updateSprintRequest,
  getSprintsRequest: projectActions.getSprintsRequest,
  getProjectTasksRequest: projectActions.getProjectTasksRequest,
};

const onCompleteHandler = ({
  selectedSprintId, projectId, sprintCRUDMeta, updateSprint, onClose, sprint, getSprintsRequest,
  getProjectTasksRequest,
}) => (formData = {}) => updateSprint({
  meta: sprintCRUDMeta,
  sprintId: selectedSprintId,
  projectId,
  ...sprint,
  status: SPRINT_STATUS.COMPLETE,
  newSprintData: formData.newSprintData,
  action: formData.action,
}, {
  ...sprintCRUDMeta,
  callbacks: {
    success: compose(
      onClose,
      () => getSprintsRequest({ projectId }),
      () => getProjectTasksRequest({
        projectId,
        withRelated: 'tasks',
        limit: 100,
        offset: 0,
      }),
      () => callNotification.success('Sprint completed successfully'),
      pathOr(identity, ['callbacks', 'success'], sprintCRUDMeta),
    ),
  },
});

const onCloseHandler = ({ onCloseModal }) => () => onCloseModal('completeSprintModal');

const enhance = compose(
  getContext({
    selectedSprintId: PropTypes.number.isRequired,
    sprintCRUDMeta: PropTypes.instanceOf(Object).isRequired,
  }),
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withSprintsCRUDHandlers,
  withHandlers({
    onComplete: onCompleteHandler,
    onClose: onCloseHandler,
  }),
);

export default enhance(CompleteSprintModal);
